import {
  SET_ISBH_DATA,
  SET_ISBH_REASON_DATA,
  SET_MODULE_DATA,
  SET_SUBMODULE_DATA
} from '../actions';
import {ModuleModel, ModuleModelActions} from '../mappers/ModuleTypesMapper';
import produce, {Draft} from 'immer';
export const initialModuleState: ModuleModel = {
  moduleData: [],
  subModuleData: [],
  isBH: false,
  isBHReason: ''
};

export const moduleReducer = produce(
  (state: Draft<ModuleModel>, action: ModuleModelActions) => {
    switch (action.type) {
      case SET_MODULE_DATA:
        // eslint-disable-next-line no-case-declarations
        const listData: any = action.payload?.data;
        state.moduleData = listData;
        break;
      case SET_SUBMODULE_DATA:
        // eslint-disable-next-line no-case-declarations
        const data: any = action.payload?.data;
        state.subModuleData = data;
        break;
      case SET_ISBH_DATA:
        // eslint-disable-next-line no-case-declarations
        const isBHdata: any = action.payload;
        state.isBH = isBHdata;
        break;
      case SET_ISBH_REASON_DATA:
        // eslint-disable-next-line no-case-declarations
        const isBHReasondata: any = action.payload;
        state.isBHReason = isBHReasondata;
        break;
      default:
        break;
    }
  },
  initialModuleState
);
